module.exports = "/images/vendor/flag-icon-css/flags/4x3/lc.svg?1c3a5554a0d8d1afaaf56164415da91c";